import GoogleApiService from './GoogleApiService';
import GoogleApiHandler from './GoogleApiHandler';

const services = {
  maps: new GoogleApiService(GoogleApiHandler),
};

export default services;
